export const PROFILE_WIDTH_LAPTOP = 440;
export const PROFILE_WIDTH_DESKTOP = 480;

export const GRID_GUTTER_MOBILE = 20;
export const GRID_GUTTER_LAPTOP = 48;
export const GRID_GUTTER_DESKTOP = 80;

export const YAT_PAGE_SCROLLBAR_WRAPPER = 'yat-page-scrollbar-wrapper';
